import { Injectable } from '@angular/core';
import { utilityService } from '../../sharedcomponents/commonservice/utility.service';
import { AppSettings } from '../../sharedcomponents/_common/constants/app.constants';
import { ReplaySubject } from 'rxjs/ReplaySubject';
import { Observable } from 'rxjs/Observable';
import { UserGioLocation } from '../../models/user/usergioLocation';
import { geolocation } from '../../sharedcomponents/commonservice/geolocation/geoloc';
import { Ng2DeviceService } from 'ng2-device-detector';
@Injectable()
export class loyaltylogin {
  constructor(private utilserv: utilityService, private deviceService: Ng2DeviceService, private geoloc: geolocation) {}
  //Store
  private editUser = new ReplaySubject<any>(1);

  verifyLoyaltyCard(model) {
    return this.utilserv.soapPostwithoutAction(this.getLoyaltyCardEnvelope(model.loyaltyCardNumber), AppSettings.ICEUserMgmtService);
  }
  //Method will used for verify Loyalty card of user will used in step 1
  getLoyaltyCardEnvelope(cardNumber: string): string {
    const DeviceDetail = this.deviceService.getDeviceInfo();
    let userGioLocation = new UserGioLocation();
    this.geoloc.getserGioLocation().subscribe(data => {
      userGioLocation = data;
    });
    const envelope = `<s:Envelope xmlns:s="http://www.w3.org/2003/05/soap-envelope"
                                    xmlns:a="http://www.w3.org/2005/08/addressing">
                        <s:Header>
                            <a:Action s:mustUnderstand="1">http://tempuri.org/IICEUserMgmt/ScanLoyaltyCardNumber</a:Action>
                            <a:MessageID>urn:uuid:358a733a-1415-4c4c-9330-11dc549e6312</a:MessageID>
                            <a:ReplyTo>
                                <a:Address>http://www.w3.org/2005/08/addressing/anonymous</a:Address>
                            </a:ReplyTo>
                        </s:Header>
                        <s:Body>
                            <CustomerInfoRequest xmlns="http://tempuri.org/">
                                <AdditionalLastName />
                                  <Address>
                                    <Address1 />
                                    <CityCode />
                                    <CountryCode />
                                    <StateCode />
                                    <ZipCode />
                                </Address>
                                <Checksum />
                                <CustomerEmail />
                                <CustomerEmployer />
                                <CustomerOccupation />
                                <CustomerPwd />
                                <DOB />
                                <DeviceDetails xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.MicroServices.Common" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
                                  <d4p1:Appversion>${AppSettings.Appversion}</d4p1:Appversion>
                                  <d4p1:DeviceBrowser>${DeviceDetail.browser}</d4p1:DeviceBrowser>
                                  <d4p1:DeviceID>${localStorage.sessionId}</d4p1:DeviceID>
                                  <d4p1:DeviceOS>${DeviceDetail.os}</d4p1:DeviceOS>
                                  <d4p1:DeviceOS_version>${DeviceDetail.os_version}</d4p1:DeviceOS_version>
                                  <d4p1:DeviceType>${DeviceDetail.device}</d4p1:DeviceType>
                                  <d4p1:DeviceUserAgent>${DeviceDetail.userAgent}</d4p1:DeviceUserAgent>
                                  <d4p1:EndIPAddress>${sessionStorage.EndUserIP}</d4p1:EndIPAddress>
                                  <d4p1:Latitude>${userGioLocation.latitude}</d4p1:Latitude>
                                  <d4p1:Longitude>${userGioLocation.longitude}</d4p1:Longitude>
                                  <d4p1:Platform>${AppSettings.Platform}</d4p1:Platform>
                                </DeviceDetails>
                                <FirstName />
                                <KeyUID>${this.utilserv.isNull(sessionStorage.KeyUID)}</KeyUID>
                                <LanguageCode>${this.utilserv.isNull(sessionStorage.langCode)}</LanguageCode>
                                <LastName />
                                <LastOrderNumber />
                                <LoyaltyCardNumber>${cardNumber}</LoyaltyCardNumber>
                                <MiddleName />
                                <MobileNumber />
                                <PreferCountryCode />
                                <ReceivingAgentId />
                                <RegistrationCode />
                                <Session>
                                    <T1 />
                                    <T2 />
                                </Session>
                                <UserID />
                                <UserVerifiedBy />
                            </CustomerInfoRequest>
                        </s:Body>
                        </s:Envelope>`;
    return envelope;
  }

  generateOTP(otpModel) {
    return this.utilserv.soapPostwithoutAction(this.genrateOTPEnvelope(otpModel), AppSettings.ICEUserMgmtService);
  }

  // methodName,'LoyaltyCardNumber' ,loyaltyCardNumber
  // methodname: string, OTPName: string, OTPValue: string
  // Metod Used for genrating Otp will used in step 2
  genrateOTPEnvelope(otpModel): string {
    const DeviceDetail = this.deviceService.getDeviceInfo();
    let userGioLocation = new UserGioLocation();
    this.geoloc.getserGioLocation().subscribe(data => {
      userGioLocation = data;
    });
    const envelope: string = `<s:Envelope xmlns:a="http://www.w3.org/2005/08/addressing" xmlns:s="http://www.w3.org/2003/05/soap-envelope">
                        <s:Header>
                            <a:Action s:mustUnderstand="1">http://tempuri.org/IICEUserMgmt/GenerateOTPValue</a:Action>
                            <a:MessageID>urn:uuid:d97e492c-4f39-4b26-9737-023eb26613b4</a:MessageID>
                            <a:ReplyTo>
                            <a:Address>http://www.w3.org/2005/08/addressing/anonymous</a:Address>
                            </a:ReplyTo>
                        </s:Header>
                        <s:Body>
                        <GenerateOTP  xmlns="http://tempuri.org/" >
                                <DeviceDetails xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.MicroServices.Common" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
                                  <d4p1:Appversion>${AppSettings.Appversion}</d4p1:Appversion>
                                  <d4p1:DeviceBrowser>${DeviceDetail.browser}</d4p1:DeviceBrowser>
                                  <d4p1:DeviceID>${localStorage.sessionId}</d4p1:DeviceID>
                                  <d4p1:DeviceOS>${DeviceDetail.os}</d4p1:DeviceOS>
                                  <d4p1:DeviceOS_version>${DeviceDetail.os_version}</d4p1:DeviceOS_version>
                                  <d4p1:DeviceType>${DeviceDetail.device}</d4p1:DeviceType>
                                  <d4p1:DeviceUserAgent>${DeviceDetail.userAgent}</d4p1:DeviceUserAgent>
                                  <d4p1:EndIPAddress>${sessionStorage.EndUserIP}</d4p1:EndIPAddress>
                                  <d4p1:Latitude>${userGioLocation.latitude}</d4p1:Latitude>
                                  <d4p1:Longitude>${userGioLocation.longitude}</d4p1:Longitude>
                                  <d4p1:Platform>${AppSettings.Platform}</d4p1:Platform>
                                </DeviceDetails>
                                <KeyUID>${this.utilserv.isNull(sessionStorage.KeyUID)}</KeyUID>
                                <LanguageCode>${this.utilserv.isNull(sessionStorage.langCode)}</LanguageCode>
                                <MethodName>${otpModel.methodname}</MethodName>
                                <OTPName>${otpModel.OTPName}</OTPName>
                                <OTPValue>${otpModel.OTPValue}</OTPValue>
                        <Session>
                                <T1></T1>
                                <T2></T2>
                        </Session>
                        </GenerateOTP>
                        </s:Body>
                        </s:Envelope>`;

    return envelope;
  }

  loyaltyCardVerification(loyaltyCardModel) {
    return this.utilserv.soapPostwithoutAction(this.getLoyaltyCardVerificationEnvelope(loyaltyCardModel), AppSettings.ICEUserMgmtService);
  }
  // Method used for verify otp will used in step 3
  getLoyaltyCardVerificationEnvelope(loyaltyCardModel: any): string {
    const DeviceDetail = this.deviceService.getDeviceInfo();
    let userGioLocation = new UserGioLocation();
    this.geoloc.getserGioLocation().subscribe(data => {
      userGioLocation = data;
    });
    let actiontype;
    if (loyaltyCardModel.RegistrationCode != '' && loyaltyCardModel.RegistrationCode != undefined) {
      actiontype = 'http://tempuri.org/IICEUserMgmt/VerifyEmailAndPhoneUserLinking';
    } else if (loyaltyCardModel.methodName == 'LASTORDER') {
      actiontype = 'http://tempuri.org/IICEUserMgmt/ValidateLasttxnID';
    } else {
      actiontype = 'http://tempuri.org/IICEUserMgmt/VerifyOTPForLoyaltyCard';
    }
    const envelope = ` <s:Envelope xmlns:a="http://www.w3.org/2005/08/addressing" xmlns:s="http://www.w3.org/2003/05/soap-envelope">
                   <s:Header>
                        <a:Action s:mustUnderstand="1">${actiontype}</a:Action>
                        <a:MessageID>urn:uuid:358a733a-1415-4c4c-9330-11dc549e6312</a:MessageID>
                        <a:ReplyTo>
                        <a:Address>http://www.w3.org/2005/08/addressing/anonymous</a:Address>
                        </a:ReplyTo>
                    </s:Header>
                    <s:Body>
                    <ValidateOTP xmlns="http://tempuri.org/">
                    <DeviceDetails xmlns:d4p1="http://schemas.datacontract.org/2004/07/ICE.MicroServices.Common" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
                      <d4p1:Appversion>${AppSettings.Appversion}</d4p1:Appversion>
                      <d4p1:DeviceBrowser>${DeviceDetail.browser}</d4p1:DeviceBrowser>
                      <d4p1:DeviceID>${localStorage.sessionId}</d4p1:DeviceID>
                      <d4p1:DeviceOS>${DeviceDetail.os}</d4p1:DeviceOS>
                      <d4p1:DeviceOS_version>${DeviceDetail.os_version}</d4p1:DeviceOS_version>
                      <d4p1:DeviceType>${DeviceDetail.device}</d4p1:DeviceType>
                      <d4p1:DeviceUserAgent>${DeviceDetail.userAgent}</d4p1:DeviceUserAgent>
                      <d4p1:EndIPAddress>${sessionStorage.EndUserIP}</d4p1:EndIPAddress>
                      <d4p1:Latitude>${userGioLocation.latitude}</d4p1:Latitude>
                      <d4p1:Longitude>${userGioLocation.longitude}</d4p1:Longitude>
                      <d4p1:Platform>${AppSettings.Platform}</d4p1:Platform>
                    </DeviceDetails>
                    <KeyUID>${this.utilserv.isNull(sessionStorage.KeyUID)}</KeyUID>
                    <LanguageCode>${sessionStorage.langCode}</LanguageCode>
                    <LoyaltyCardNumber>${this.utilserv.isNull(loyaltyCardModel.loyaltyCardNumber)}</LoyaltyCardNumber>
                    <MethodName>${loyaltyCardModel.methodName}</MethodName>
                    <MobileNumber></MobileNumber>
                    <OTP>${loyaltyCardModel.otpValue}</OTP>
                    <RegistrationCode>${this.utilserv.isNull(loyaltyCardModel.RegistrationCode)}</RegistrationCode>
                    <Session>
                    <T1></T1>
                    <T2></T2>
                    </Session>
                    <UserID></UserID>
                    </ValidateOTP>
                    </s:Body>
                    </s:Envelope>`;

    return envelope;
  }

  /// Store User Data
  setEditUserData(dataValues: any) {
    this.editUser.next(dataValues);
  }

  getEditUserData(): Observable<any> {
    return this.editUser.asObservable();
  }

  clearUserData() {
    this.editUser.next(null);
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/userservice/user.loyaltylogin.service.ts